export enum ScreenNamesForBigQuery {
  WORKLIST = "worklist",
  SETTINGS = "settings",
  ALL_PA_ORDERS = "all_pa_orders",
  MY_PA_ORDERS = "my_pa_orders",
  AUTH_REQUIRED_PA = "auth_required_table",
  AUTH_ON_FILE_PA = "auth_on_file_table",
  HOLD_PA = "hold_table",
  PENDING_PA = "pending_pa_table",
  DENIED_BY_RISA_PA = "denied_by_risa_pa_table",
  POD_PA = "pod_pa_table",
  NAR_PA = "nar_pa_table",
  NOT_TO_WORK_ORAL_PA = "not_to_work_oral_pa_table",
  NOT_TO_WORK_FEDORAL_PA = "not_to_work_fedoral_pa_table",
  NOT_TO_WORK_STAT = "not_to_work_stat_pa_table",
  QUERY_PA = "query_pa_table",
  FINAL_WORKLIST_TABLE = "final_worklist_table",
  FINAL_WORKLIST_UPLOAD = "final_worklist_upload",
  COVERAGE_SCREEN = "coverage_screen",
  AUTH_STATUS_SCREEN = "auth_status_screen",
  CPT_CODE_SCREEN = "cpt_code_screen",
  BUSNIESS_OFFICE_SCREEN = "business_office_screen",
  TREATMENT_PLAN_SCREEN = "treatment_plan_screen",
  VISIT_DATA_CHART_SCREEN = "visit_data_chart_screen",
  DOCUMENTS_SCREEN = "documents_screen",
  FORM_SCREEN = "form_screen",
  FINAL_DOCUMENT_SCREEN = "final_document_screen",
  SUBMISSION_STATUS_SCREEN = "submission_status_screen",
  AUTH_LETTERS_SCREEN = "auth_letters_screen",
  AUTHORISATION_DETAILS_SCREEN = "authorisation_details_screen",
}

/** Entry points for {@link EventsName.MANUAL_EV_EDIT_CLICKED} on the EV coverage screen. */
export enum ManualEvEditClickSource {
  EDIT_BUTTON = "edit_button",
  UPDATE_MANUALLY = "update_manually",
}

/** Plan-summary field keys for {@link EventsName.MANUAL_EV_FIELD_EDITED}. */
export enum ManualEvEvFieldKey {
  PLAN_NAME = "plan_name",
  MEMBER_ID = "member_id",
  PLAN_STATUS = "plan_status",
  EFFECTIVE_DATE = "effective_date",
  PLAN_END_DATE = "plan_end_date",
}

/** BV financial section keys for {@link EventsName.MANUAL_EV_FIELD_EDITED}. */
export enum ManualEvBvFieldKey {
  DEDUCTIBLE = "deductible",
  OUT_OF_POCKET = "out_of_pocket",
  COPAY = "copay",
  CO_INSURANCE = "co_insurance",
}

/** Total vs used for deductible/OOP rows in {@link EventsName.MANUAL_EV_FIELD_EDITED}. */
export enum ManualEvBvAmountType {
  TOTAL = "total",
  USED = "used",
}

/** Individual vs family subscriber tier for deductible/OOP analytics. */
export enum ManualEvBvSubscriberKind {
  INDIVIDUAL = "individual",
  FAMILY = "family",
}

export enum ModalNamesForBigQuery {
  ASSIGNED_TO_MODAL = "assigned_to_modal",
  BO_NOTES_SCREENSHOT_MODAL = "bo_notes_screenshot_modal",
  COVERAGE_SCREENSHOT_MODAL = "coverage_screenshot_modal",
  TREATMENT_PLAN_SCREENSHOT_MODAL = "treatment_plan_screenshot_modal",
  VALIDATE_EV_BV_DATA_MODAL = "validate_ev_bv_data_modal",
  REPORT_INACCURACY_MODAL = "report_inaccuracy_modal",
  RAISE_QUERY_MODAL = "raise_query_modal",
  MARK_AS_COMPLETED_MODAL = "mark_as_completed_modal",
  JCODE_CONFIRMATION_MODAL = "jcode_confirmation_modal",
  BO_WRITE_BACKCONFIRMATION_MODAL = "bo_confirmation_modal",
  NCCN_GUIDELINES_MODAL = "nccn_guidelines",
  FINAL_ATTACHMENTS_MODAL = "final_attachments_modal",
  FORM_SELECTION_MODAL = "form_selection_modal",
  HAPPY_FLOW_MODAL = "happy_flow_modal",
  COMMENT_RPA_MODAL_NEW = "comment_rpa_modal_new",
  CLINICAL_DATA_TABLE = "clinical_data_table",
}
